import type { QuestionnaireRevisionContext } from '@gcv/shared';
import { QuestionnaireStatus } from '@gcv/shared';

export const hasPendingRevision = (history: QuestionnaireRevisionContext[] | undefined): boolean => {
  if (!history?.length) return false;
  return history.some((entry) => entry.status === QuestionnaireStatus.Open);
};
